import React from "react";
import InfoIcon from "../../components/info-icon/info-icon";
import { Button } from "../../components/button/button";
import { EncircledPlusIcon } from "../../utils/svg-components";
import { Typography } from "@mui/material";

const ComponentPage = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <Typography variant="h1">Heading 1</Typography>
        <Typography variant="h2">Heading 2</Typography>
        <Typography variant="h3">Heading 3</Typography>
        <Typography variant="h4">Heading 4</Typography>
        <Typography variant="h5">Heading 5</Typography>
        <Typography variant="h6">Heading 6</Typography>
      </div>

      <div
        style={{
          width: "800px",
          display: "flex",
          flexDirection: "column",
          gap: "25px",
        }}
      >
        <Typography variant="body1">
          Body Medium. Most fonts have a particular weight which corresponds to
          one of the numbers in Common weight name mapping. However some fonts,
          called variable fonts, can support a range of weights with a more or
          less fine granularity, and this can give the designer a much closer
          degree of control over the chosen weight.
        </Typography>

        <Typography variant="body2">
          Body Small. Most fonts have a particular weight which corresponds to
          one of the numbers in Common weight name mapping. However some fonts,
          called variable fonts, can support a range of weights with a more or
          less fine granularity, and this can give the designer a much closer
          degree of control over the chosen weight.
        </Typography>

        <Typography variant="body3">
          Body Extra Small. Most fonts have a particular weight which
          corresponds to one of the numbers in Common weight name mapping.
          However some fonts, called variable fonts, can support a range of
          weights with a more or less fine granularity, and this can give the
          designer a much closer degree of control over the chosen weight.
        </Typography>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Button variant="filled">
          <EncircledPlusIcon />
        </Button>

        <Button variant="filled" startIcon={<EncircledPlusIcon />}>
          Hello
        </Button>

        <Button variant="filled" endIcon={<EncircledPlusIcon />}>
          Hello
        </Button>

        <Button
          variant="filled"
          startIcon={<EncircledPlusIcon />}
          endIcon={<EncircledPlusIcon />}
        >
          Hello
        </Button>

        <Button
          variant="filled"
          color={"tertiary"}
          startIcon={<EncircledPlusIcon />}
          endIcon={<EncircledPlusIcon />}
        >
          Hello
        </Button>
      </div>

      <div style={{ margin: "10px 100px", display: "flex", gap: "50px" }}>
        <InfoIcon
          message={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. "}
        />
        <InfoIcon
          placement={"bottom"}
          message={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. "}
        />

        <InfoIcon
          placement={"right"}
          message={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. "}
        />
        <InfoIcon
          placement={"left"}
          message={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. "}
        />
      </div>
    </div>
  );
};

export default ComponentPage;
